import React from 'react';
import GlobalStyle from './GlobalStyles';

import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import SignIn from './components/SignIn';
import Home from './components/Home';
import Header from './components/Header';
import Footer from './components/Footer/Footer';
import { DataReview } from './components/DataReview';
import styled from 'styled-components';
import { useAuth } from './components/Authorization/AuthContext';
import { AuthCallback } from './components/Authorization/AuthCallback';
import { MsalAuthCallback } from './components/Authorization/MsalAuthCallback';
import RequireProjectSelection from './components/Authorization/RequireProjectSelection';

function RequireAuth({ children }: { children: JSX.Element }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return <RequireProjectSelection>{children}</RequireProjectSelection>;
}

function App() {
  const { isAuthenticated, signinRedirect, msalSignIn } = useAuth();
  return (
    <Router>
        <React.Fragment>
          <GlobalStyle />
          <Header />
          <MainContent>
            <Routes>
              <Route path="/auth" element={<AuthCallback />} />
              <Route path="/auth/msal" element={<MsalAuthCallback />} />
              <Route path="/" element={isAuthenticated ? <RequireAuth><Home /></RequireAuth> : <SignIn onSignIn={signinRedirect} onMsalSignIn={msalSignIn} />} />
              <Route path="/home" element={<RequireAuth><Home /></RequireAuth>} />
              <Route path="/data_review" element={<RequireAuth><DataReview /></RequireAuth>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </MainContent>
          <Footer />
        </React.Fragment>
    </Router>
  );
}

const MainContent = styled.main`
  padding-top: 100px; /* Adjust if you have a fixed header */
  padding-bottom: 40px; /* Adjust if you have a fixed footer */
`;
export default App;

